import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'

import s from './styles.module.scss'

export const HeaderCalendar = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  return (
    <div className={s.header}>
      <Header
        title={t('when')}
        isFixed={false}
        actionLeft={
          <AppIcon
            id={AllIcons.ARROW_LEFT}
            className={s.icon}
            onClick={() => navigate(-1)}
          />
        }
      />
    </div>
  )
}
